import {LocationProps} from '../components/sections/Location/LocationCard';

const COMMON_OPENING: LocationProps['opening'] = [
  { day: 'Monday',    open: '7:00', close: '19:00' },
  { day: 'Tuesday',   open: '7:00', close: '19:00' },
  { day: 'Wednesday', open: '7:00', close: '19:00' },
  { day: 'Thursday',  open: '7:00', close: '19:00' },
  { day: 'Friday',    open: '7:00', close: '19:00' },
];

// 5% discount for 15 hours and above for babies
// Early start is from 7amto 8 am and late finish is from 6pm to 7pm. Normal opening hours are 8am to 6pm
export const RomfordLocation: LocationProps = 
{
    slug: 'romford',
    name: 'Romford',
    address: '42 Mawney Rd, Romford RM7 7HT, United Kingdom',
    phoneDisplay: '+44 7983 133002',
    phoneTel: '+447983133002',
    landlineDisplay: '+44 1708 912584',
    landlineTel: '+441708912584',
    email: 'Admin@greatchild.co.uk', // global emails also in footer
    whatsappUrl: 'https://api.whatsapp.com/send?phone=%2B447983133002&app=facebook&entry_point=page_cta&fbclid=IwY2xjawMEHOFleHRuA2FlbQIxMABicmlkETEyTkVQVTVRZWZwWU1yZFRKAR6AqPKi1tfgL973A9VP2oAlQsuqp6jYgOU_OwZPd0qYZmKJwqOCciF2vNS76A_aem_rgVu-lMZamG50i8XkxXAnQ',
    facebookUrl: 'https://www.facebook.com/p/Great-Child-Nursery-Romford-100063552731450/',
    instagramUrl: 'https://www.instagram.com/greatchildnursery/?hl=en',
    mapsEmbedQuery: '42 Mawney Rd, Romford RM7 7HT, United Kingdom',
    opening: COMMON_OPENING
  };
export const TilburyLocation: LocationProps = 
 {
    slug: 'tilbury',
    name: 'Tilbury',
    address: '110 Dock Rd, Tilbury RM18 7BT, United Kingdom',
    phoneDisplay: '+44 7735 190901',
    phoneTel: '+447735190901', 
    landlineDisplay: '+44 1375 843155',
    landlineTel: '+441375843155',
    email: 'Admin@greatchild.co.uk',
    whatsappUrl: 'https://api.whatsapp.com/send?phone=%2B447735190901&app=facebook&entry_point=page_cta&fbclid=IwY2xjawMEHI5leHRuA2FlbQIxMABicmlkETEyTkVQVTVRZWZwWU1yZFRKAR6YK97KzZSijZbwvFsyjTnSNb7O5jd2xLmJknKIp_sut-4QHMkKi7azIoIo1Q_aem_TnSCcQeMPazokeMQi8Zx0g',
    facebookUrl: 'https://www.facebook.com/p/Great-Child-Nursery-100047579692622/',
    instagramUrl: 'https://www.instagram.com/greatchildnursery/?hl=en',
    mapsEmbedQuery: '110 Dock Rd, Tilbury RM18 7BT, United Kingdom',
    opening: COMMON_OPENING,
  };
  
export const LOCATIONS: LocationProps[] = [
  RomfordLocation,
  TilburyLocation,
];
